import { useState } from "react";
import {
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { formatNumber, formatDate } from "../../Utils/utils";
import Alert from "@mui/material/Alert";
import { DataGridTable } from "../Table";
import { DataTabs } from "../LabTabs";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import Tooltip from "@mui/material/Tooltip";
import {isTestEnv} from "../../globals";

export const OpenOrders = ({ OpenOrders }) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [expandedPanel, setExpandedPanel] = useState(false);
  const handleChange = (event, isExpanded) => {
    setExpandedPanel(isExpanded);
  };

  const handleOpenPopup = (order) => {
    isTestEnv && console.log("order", order);
    setSelectedOrder(order);
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setSelectedOrder(null);
  };

  const dataGridColumns = [
    {
      field: "ORDNAME",
      headerName: "מספר הזמנה",
      cellClassName: "first-column",
    },
    {
      field: "CURDATE",
      headerName: "תאריך הזמנה",
      renderCell: (params) => formatDate(params.value),
    },
    { field: "CUSTNAME", headerName: "מספר לקוח" },
    { field: "CUSTDES", headerName: "שם לקוח" },
    { field: "Y_16227_5_ESHB", headerName: "תת חברה" },
    {
      field: "PRICEBAL2",
      headerName: "שווי יתרה משוערך",
      renderCell: (params) => formatNumber(params.value),
    },
    { field: "CODE2", headerName: "מטבע" },
    {
      field: "STATUSICON",
      headerName: "פירוט הזמנה",
      renderCell: (params) => (
        <Tooltip title="הצג פירוט">
          <IconButton onClick={() => handleOpenPopup(params.row)}>
            <LaunchIcon />
          </IconButton>
        </Tooltip>
      ),
      sortable: false,
      filterable: false,
      minWidth: 100,
      flex: 0.1,
    },
  ];
  let groupedData = [];
  // Each order is represented by its number of products. Each product appears as a separate row.
  if (OpenOrders) {
    let mainIdCounter = 1;
    let detailsIdCounter = 1;
    groupedData = Object.values(
      OpenOrders?.reduce((acc, item) => {
        const {
          ORDNAME,
          CURDATE,
          CUSTNAME,
          CUSTDES,
          Y_7449_5_ESHB,
          Y_16227_5_ESHB,
          PARTNAME,
          PDES,
          PRICEBAL1,
          CODE,
          PRICEBAL2,
          CODE2,
        } = item;

        // If group for ORDNAME doesn't exist, initialize it
        if (!acc[ORDNAME]) {
          acc[ORDNAME] = {
            id: mainIdCounter++, // Add unique ID to the main group
            CUSTNAME,
            CUSTDES,
            CURDATE,
            ORDNAME,
            PRICEBAL2: 0,
            CODE2,
            Y_7449_5_ESHB,
            Y_16227_5_ESHB,
            ORDERITEMS_SUBFORM: [],
          };
        }

        acc[ORDNAME].ORDERITEMS_SUBFORM.push({
          id: detailsIdCounter++,
          PARTNAME,
          PDES,
          PRICEBAL1,
          CODE,
          PRICEBAL2,
          CODE2,
        });
        acc[ORDNAME].PRICEBAL2 += PRICEBAL2;
        return acc;
      }, {})
    );
    console.log("groupedData", groupedData);
  }

  const OOrders = OpenOrders?.map((row, index) => ({
    ...row,
    id: index,
    ORDERITEMS_SUBFORM: row?.ORDERITEMS_SUBFORM?.map((sub_row, sub_index) => ({
      ...sub_row,
      id: sub_index,
    })),
  }));
  isTestEnv && console.log("OOrders.length", OOrders?.length);

  const columns_ORDERITEMS_SUBFORM = [
    {
      field: "PDES",
      headerName: "תאור מוצר",
    },
    {
      field: "PARTNAME",
      headerName: 'מק"ט',
    },
    {
      field: "PRICEBAL1",
      headerName: "שווי יתרה",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "CODE",
      headerName: "מטבע",
    },
    {
      field: "PRICEBAL2",
      headerName: "שווי יתרה משוערך",
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "CODE2",
      headerName: "מטבע",
    },
  ];
  return (
    <Accordion
      expanded={expandedPanel}
      onChange={handleChange}
      disabled={OpenOrders === null}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel-content"
        id="panel-header"
        style={{
          backgroundColor: expandedPanel ? "#f0f0f0" : "inherit",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
          >
            הזמנות פתוחות
          </span>
        </div>
      </AccordionSummary>
      {groupedData?.length === 0 ? (
        <Alert severity="info">אין הזמנות פתוחות ללקוח</Alert>
      ) : (
        <div>
          <AccordionDetails
            style={{
              maxHeight: "calc(100vh - 100px)", // Adjust the height as needed
              overflowY: "auto",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>
                  {dataGridColumns !== "undefined" && OpenOrders && (
                    <DataTabs
                      data={groupedData}
                      columns={dataGridColumns}
                      TabKey={{ value: "Y_7449_5_ESHB", label: "סניף" }}
                    />
                  )}
                </Typography>
              </Grid>
            </Grid>
          </AccordionDetails>
        </div>
      )}
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        maxWidth={false}
        PaperProps={{
          style: {
            maxWidth: "calc(100% - 50px)",
            maxHeight: "calc(100% - 50px)",
            width: "70vw",
            height: "50vh",
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "left" }}>פרטי הזמנה</DialogTitle>
        <DialogContent>
          {selectedOrder?.ORDERITEMS_SUBFORM?.length > 0 ? (
            <DataGridTable
              rows={selectedOrder.ORDERITEMS_SUBFORM || []}
              columns={columns_ORDERITEMS_SUBFORM}
            />
          ) : (
            <Typography variant="body1" color="textSecondary">
              אין פריטים להזמנה זו
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </Accordion>
  );
};
